document.addEventListener('DOMContentLoaded', function () {

  // 1. Scroll-reveal animation for cards/sections
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));

  // 2. Sticky nav shadow on scroll
  const nav = document.getElementById('siteNav');
  if (nav) {
    window.addEventListener('scroll', () => nav.classList.toggle('scrolled', window.scrollY > 8));
  }

  // 3. Mobile menu toggle
  const menuBtn = document.getElementById('menuBtn');
  const mobileMenu = document.getElementById('mobileMenu');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', open);
    });
    mobileMenu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      menuBtn.setAttribute('aria-expanded', 'false');
    }));
  }

  // 4. Animated count-up stats (About section)
  const counters = document.querySelectorAll('[data-count]');
  const countIo = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const target = parseInt(el.dataset.count, 10);
      const suffix = el.dataset.suffix || '';
      const duration = 1100;
      const start = performance.now();
      function tick(now) {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(target * eased).toLocaleString() + suffix;
        if (progress < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
      countIo.unobserve(el);
    });
  }, { threshold: 0.4 });
  counters.forEach(el => countIo.observe(el));

  // 5. Hero Slider Auto-rotation & Controls
  const slider = document.querySelector('[data-slider]');
  if (slider) {
    const slides = slider.querySelectorAll('.lux-hero-slide');
    const dots = slider.querySelectorAll('.lux-hero-dot');
    let currentSlide = 0;
    let slideInterval;

    function goToSlide(index) {
      slides[currentSlide].classList.remove('active');
      if (dots.length) dots[currentSlide].classList.remove('active');
      currentSlide = (index + slides.length) % slides.length;
      slides[currentSlide].classList.add('active');
      if (dots.length) dots[currentSlide].classList.add('active');
    }

    function startSlider() {
      slideInterval = setInterval(() => {
        goToSlide(currentSlide + 1);
      }, 5000);
    }

    if (slides.length > 1) {
      startSlider();
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          clearInterval(slideInterval);
          goToSlide(index);
          startSlider();
        });
      });
    }
  }

  // 6. Quick Add / Dynamic Product Modal Handler
  document.querySelectorAll('.lux-quick-add, .quick-add').forEach(btn => {
    btn.addEventListener('click', function (e) {
      const urlContainer = this.closest('[data-product-url]');
      const productUrl = urlContainer ? urlContainer.dataset.productUrl : null;

      if (productUrl) {
        e.preventDefault();
        
        // Create or target the dynamic modal container on the page
        let modal = document.getElementById('luxQuickModal');
        if (!modal) {
          modal = document.createElement('div');
          modal.id = 'luxQuickModal';
          modal.innerHTML = '<div class="lux-modal-content"><button id="luxCloseModal">&times;</button><div id="luxModalBody">Loading options...</div></div>';
          document.body.appendChild(modal);

          modal.querySelector('#luxCloseModal').addEventListener('click', () => {
            modal.style.display = 'none';
          });
          modal.addEventListener('click', (ev) => {
            if (ev.target === modal) modal.style.display = 'none';
          });
        }

        modal.style.display = 'flex';
        const modalBody = modal.querySelector('#luxModalBody');
        modalBody.innerHTML = 'Loading options...';

        // Fetch the specific product page fragment to load its options and buy form dynamically
        fetch(`${productUrl}?section_id=main-product`)
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const productMain = doc.querySelector('form[action*="/cart/add"]') || doc.querySelector('.product-section') || doc.querySelector('main');
            if (productMain) {
              modalBody.innerHTML = '';
              modalBody.appendChild(productMain);
            } else {
              modalBody.innerHTML = `<p>View product details directly: <a href="${productUrl}" style="text-decoration:underline; font-weight:bold;">Click here</a></p>`;
            }
          })
          .catch(() => {
            modalBody.innerHTML = `<p>Unable to load options. <a href="${productUrl}">Click here to view product page</a>.</p>`;
          });
      }
    });
  });

});